import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import { calcValue } from '../../../utils/functionsCss';

const MainAvatarEdition = styled.div`
  max-width: 100%;
  overflow: hidden;
`;

const StyledAvatarEdition = styled.div`
  display: flex;
  height: ${rem('120px')};

  ${props =>
    props.numElements &&
    `
    width: calc(${props.numElements} * 155px);  
  `};

  ${mediaqueries.greaterThan('desktop')`
    flex-flow: column wrap;
    height: 75vh;
    ${props =>
      props.numElements &&
      `
      width: ${calcValue(props.numElements, 4, 4)}%;  
    `}
  `};
`;

const AvatarItem = styled.button`
  background: none;
  border: 0;
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 0 ${rem('10px')};
  width: ${rem('155px')};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: calc(50% - ${rem('76px')});
    bottom: ${rem('-10px')};
    width: ${rem('152px')};
    height: ${rem('7px')};
    background-color: ${props =>
      props.isActive ? props.theme.colors.primary : `transparent`};
    ${mediaqueries.greaterThan('desktop')`
    bottom: 0;   
  `};
  }

  &:hover:after {
    background-color: ${props => props.theme.colors.primary};
  }

  ${mediaqueries.greaterThan('desktop')`
    height: calc(100% / 4) ;
    padding: 1.25rem;
    width: calc(100% / 4);    
  `};
`;

const StyledIcon = styled(Icon)`
  width: 100%;
  max-height: 100%;
`;

export { MainAvatarEdition, StyledAvatarEdition, AvatarItem, StyledIcon };
